import { ExpertGenderRole } from "../types/ExpertGenderRole";
import { ExpertRole } from "../types/ExpertRole";

export const getGenderTitle = (sex: string) => {
  return sex === "F" ? ExpertGenderRole.Dottssa : ExpertGenderRole.Dott;
};

export const getRoleTitle = (role: ExpertRole) => {
  switch(role) {
    case ExpertRole.Nutritionist:
      return "Nutrizionista";
    case ExpertRole.Physician:
      return "Endocrinologo";
    default:
      return "Medico refertante";
  }
};